import React from 'react';
import { StyledButtonWithTooltip, StyledTooltip } from './ButtonWithTooltip.style';

export interface IButtonWithTooltipProps {
  children: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  tooltip?: string;
  marginRight?: any;
}

export default function ButtonWithTooltip(props: IButtonWithTooltipProps) {
  const { children, onClick, disabled, tooltip, marginRight } = props;

  const button = (
    <StyledButtonWithTooltip variant="outlined" marginRight={marginRight} onClick={onClick} disabled={disabled}>
      {children}
    </StyledButtonWithTooltip>
  );

  return !!tooltip ? (
    <StyledTooltip title={tooltip} arrow placement="top">
      {button}
    </StyledTooltip>
  ) : (
    button
  );
}

export const defaultProps = {
  children: 'Button With Tooltip',
  onClick: () => {},
  disabled: false,
  style: {},
  tooltip: 'Label tooltip button',
};
ButtonWithTooltip.defaultProps = defaultProps;
